import { sendRequest } from "../axios";

export default {
  state: {
    config: [],
    date: null,
    bank_id: null,
    site_id: null,
    product_id: null,
    bank_rate: null
  },
  mutations: {
    setConfig(state, payload) {
      state.config = payload;
    },
    setConfigDate(state, payload) {
      state.date = payload;
    },
    setBankId(state, payload) {
      state.bank_id = payload;
    },
    setSiteId(state, payload) {
      state.site_id = payload;
    },
    setBankRate(state, payload) {
      state.bank_rate = payload;
    },
    setProductId(state, payload) {
      state.product_id = payload;
    }
  },
  actions: {

    //likes Actions
    async USERS_LIKES_BANK(state,payload){
      const {data} = await sendRequest(`/api/likeBank`,'post',payload)
      return data
    },
    async USERS_LIKES_SITE(state,payload){
      const {data} = await sendRequest(`/api/likeSite`,'post',payload)
      return data
    },

    //config Actions
    async GET_RATING_CONFIG({ commit }) {
      const { data } = await sendRequest("api/ratingConfig", "get");
      commit("setConfig", Array.from(data.params));
      commit("setConfigDate", data.date);
    },
    async SET_RATING_CONFIG({ commit }, payload) {
      const { data } = await sendRequest("/api/ratingConfig", "put", {
        config: {
          name: payload.params,
          description: payload.paramsDescription,
          rate: 3
        }
      });
      commit("setConfig", Array.from(data.params));
      commit("setConfigDate", data.date);
    },
    // async REMOVE_RATING_CONFIG({commit},payload){
    //   const {data}= await sendRequest(`/api/ratingConfig/,'delete'${payload}`)
    //   commit('setConfig',Array.from(data.params))
    //   commit('setConfigDate',data.date)
    // },
    async EDIT_RATING_CONFIG({ dispatch }, payload) {
      const { data } = await sendRequest("/api/ratingConfig", "post", {
        config: { ...payload }
      });
      data && (await dispatch("GET_RATING_CONFIG"));
    },

    // CRUD Actins by bank an site rating below
    async SET_RATE_AND_COMMENT_FOR_BANK(state, payload) {
      const saveObj = {
        actions: "save",
        ...payload
      };

      const { data } = await sendRequest(`/api/bankRating`, "post", saveObj);
      return data;
    },
    async SET_RATE_AND_COMMENT_FOR_SITE(state, payload) {
      const saveObj = {
        actions: "save",
        ...payload
      };

      const { data } = await sendRequest(`/api/siteRating`, "post", saveObj);
      return data;
    },
    async GET_BANK_COMMENT(state, payload) {
      const saveObj = {
        actions: "get",
        ...payload
      };
      const { data } = await sendRequest(`/api/bankRating`, "post", saveObj);
      return data.comments;
    },
    async GET_SITE_COMMENT(state, payload) {
      const saveObj = {
        actions: "get",
        ...payload
      };
      const { data } = await sendRequest(`/api/siteRating`, "post", saveObj);
      return data.comments;
    },
    async GET_USER_BANK_INFO(state, payload) {
      const saveObj = {
        actions: "userRatingInfo",
        ...payload
      };
      const { data } = await sendRequest(`/api/bankRating`, "post", saveObj);
      return data;
    },
    async GET_USER_SITE_INFO(state, payload) {
      const saveObj = {
        actions: "userRatingInfo",
        ...payload
      };
      const { data } = await sendRequest(`/api/siteRating`, "post", saveObj);
      return data;
    },
    async REMOVE_USER_RATE_FROM_BANK(state, payload) {
      const saveObj = {
        actions: "deleteRateAndComment",
        ...payload
      };
      const { data } = await sendRequest(`/api/bankRating`, "post", saveObj);
      return data;
    },
    async REMOVE_USER_RATE_FROM_SITE(state, payload) {
      const saveObj = {
        actions: "deleteRateAndComment",
        ...payload
      };
      const { data } = await sendRequest(`/api/siteRating`, "post", saveObj);
      return data;
    },
    async All_BANK(state) {
      const getObj = {
        actions: "allBank"
      };
      const { data } = await sendRequest(`/api/bankRating`, "post", getObj);
      return data;
    },
    async ALL_SITE_RETING(state) {
      const { data } = await sendRequest(`/api/siteRating`, "get");
      return data;
    },
    async ALL_BANKS_COMMENTS(state){
      const getObj = {
        actions: 'AllBanksComments'
      }
      const {data} = await sendRequest(`/api/bankRating`,'post', getObj)
      return data
    },
    async ALL_SITES_COMMENTS(state){
      const getObj = {
        actions: 'AllSitesComments'
      }
      const {data} = await sendRequest(`/api/siteRating`,'post', getObj)
      return data
    }

  },
  getters: {
    ratingConfig: state => state.config,
    get_bank_id: state => state.bank_id,
    get_site_id: state => state.site_id,
    get_bank_rate: state => state.bank_rate,
    get_product_id: state => state.product_id
  }
};
